
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#58697D"}},[_c('path',{attrs:{"d":"M11.5 4L10 13H4L2.5 4h1.014l1.333 8h4.305l1.334-8H11.5zM9.145 2c-.45 0-.816-.55-.816-1H5.671c0 .45-.365 1-.816 1H2v1h10V2H9.145z"}}),_c('path',{attrs:{"d":"M6.168 11.722a.35.35 0 01-.39-.303l-.875-7a.35.35 0 01.694-.087l.875 7a.35.35 0 01-.304.39zM9.097 4.418a.35.35 0 00-.694-.086l-.875 7a.35.35 0 00.694.086l.875-7z"}})])])
          )
        }
      }
    